module.exports = __webpack_public_path__ + "login.620288e30ef2475ffadf.jpg";


//////////////////
// WEBPACK FOOTER
// /home/codevi/Documents/PROJET/resa-parklife/front/src/assets/images/login.jpg
// module id = ../../../../../src/assets/images/login.jpg
// module chunks = styles